export enum AlternativeCurrenciesVendors {
  Hicv = 'hicv',
  Rci = 'rci',
  Dri = 'dri'
}
